// extracted by mini-css-extract-plugin
export default {"projects":"style_projects__xZ6tH","projectsLogo":"style_projectsLogo__cz2R3","title":"style_title__9lRmJ","line":"style_line__ehlRh","projectsMain":"style_projectsMain__WBdcm"};